import { RouteNames } from "~~/server/enums";

type UseAuthReturn = {
  logout: () => Promise<void>;
  login: () => Promise<void>;
};

export function useAuth(): UseAuthReturn{
  const { $login, $logout } = useNuxtApp();
  const { store } = useUser();

  async function login(): Promise<void> {
    clearSiteData(); // MSAL allows users to switch accounts, clearing site data ensures that no remnants of the previous session remain.
    const loginResponse = await $login();
    if (loginResponse == null) throw new Error('Failed to login user.');
    navigateTo(RouteNames.PREDICTION);
  }

  async function logout(): Promise<void> {
    const logoutResponse = await $logout();
    clearSiteData();
    if (logoutResponse == null) throw new Error('Failed to logout user.');
    navigateTo(RouteNames.LOGIN);
  }

  function clearSiteData(): void {
    document.cookie.split(";").forEach((cookie) => {
      const [name, _] = cookie.split("=").map((c) => c.trim());
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });

    localStorage.clear();
    sessionStorage.clear();
    store.reset();
  }

  return {
    login,
    logout,
  };
}
